<template>
  <gg-dialog
    :model-value="state.isOpen"
    :title="state.title"
    :max-width="state.width"
    :persistent="state.persistent"
    :no-auto-fullscreen="state.noAutoFullscreen"
    @update:model-value="handleDialogUpdate"
    @cancel="handleCancel"
  >
    <!-- Content -->
    <p class="text-body-1 ma-0">{{ state.content }}</p>

    <!-- Actions -->
    <template #actions>
      <gg-btn
        variant="text"
        @click="handleCancel"
      >
        {{ state.cancelText }}
      </gg-btn>

      <v-spacer />

      <gg-btn
        :color="state.confirmColor"
        @click="handleConfirm"
      >
        {{ state.confirmText }}
      </gg-btn>
    </template>
  </gg-dialog>
</template>

<script setup lang="ts">
/**
 * ConfirmDialogProvider Component
 *
 * Global provider for the useConfirmDialog composable.
 * Place this component in your root App.vue to enable programmatic confirmation dialogs.
 *
 * @version 3.1.0
 * @description Uses GgDialog with #actions slot. Forwards `noAutoFullscreen` from
 *              ConfirmDialogOptions for compact popup mode on mobile.
 *
 * Usage: Import and add <ConfirmDialogProvider /> to App.vue template.
 * Then use useConfirmDialog() composable anywhere to show confirmation dialogs.
 */

import { useConfirmDialog } from '@/composables/useConfirmDialog'

const { state, handleConfirm, handleCancel } = useConfirmDialog()

function handleDialogUpdate(value: boolean) {
  if (!value && !state.persistent) {
    handleCancel()
  }
}
</script>
